export default __webpack_public_path__ + "static/media/biofit-builder-series-RX.c6833513.png";